import React from 'react';

import { useIntl } from 'react-intl';
import { Button, Form, Input, notification } from 'antd';
import { useHistory } from 'react-router-dom';

import IntlMessages from 'util/IntlMessages';
import BoxContainer from 'components/BoxContainer';
import { KeyValueWidget } from 'components/KeyValueWidget';
import Title from 'components/BoxContainer/components/Title';
import useCloudFunction from 'packages/utils/hooks/clouds/useCloudFunction';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import Card from '../components/Card';
import { signInDt } from '../../contexts/AuthProvider';
import { useToggle } from 'packages/utils';

export const EnterPassword = () => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const history = useHistory();
  const [isLoading, loadingToggle] = useToggle(false);
  const {
    mutateAsync: checkEmailDt,
    loading: checkEmailLoading
  } = useCloudFunction({
    op: API_OPERATIONS.MAIL_VALIDATION_DT,
    runFirstTime: false,
  });

  const { state: { email, hasCode = false } = {} } = history.location;

  const mainLoading = checkEmailLoading || isLoading;

  const onSubmit = async values => {
    try {
      loadingToggle();

      await signInDt({ email, code: values.code });
    } catch (error) {
      form.setFields([
        {
          name: 'code',
          errors: [intl.formatMessage({ id: 'work.direction.auth.enter.password.error' })],
        },
      ]);
    } finally {
      loadingToggle();
    }
  };

  const onRequestNewPassword = async () => {
    try {
      if (!email) throw new Error('Missing email');

      const { error } = await checkEmailDt({ email });

      if (error) throw new Error(error);

      notification.success({
        message: intl.formatMessage({ id: 'work.direction.auth.resent' }),
      });
    } catch (error) {
     form.setFields([
        {
          name: 'code',
          errors: [intl.formatMessage({ id: 'general.save.error.message' })],
        },
      ]);
    }
  };

  return (
    <BoxContainer>
      <BoxContainer content loading={mainLoading}>
        <Form onFinish={onSubmit} name="enterPassword" form={form}>
          <Card
            title={
              <>
                <div className="gx-text-center">
                  <IntlMessages
                    id={
                      hasCode
                        ? 'work.direction.auth.enter.already.code'
                        : 'work.direction.auth.enter.password.title'
                    }
                  />
                </div>
                <div className="gx-text-center gx-mt-3 gx-fs-md">{email}</div>
              </>
            }
          >
            <KeyValueWidget
              label={
                <Title.LabelForm value={<IntlMessages id="work.direction.auth.enter.password" />} />
              }
              value={
                <Form.Item name="code" className="gx-ml-3 gx-mr-3">
                  <Input className="gx-mb-1 gx-mt-2" />
                </Form.Item>
              }
            />
            <p className="gx-mt-2">
              <IntlMessages id="work.direction.auth.enter.password.description" />
            </p>
            <div>
              <Form.Item noStyle shouldUpdate>
                {({ getFieldValue }) => (
                  <Button
                    disabled={!getFieldValue('code')}
                    htmlType="submit"
                    block
                    className="gx-mt-3 gx-w-100"
                    type="primary"
                  >
                    <IntlMessages id="work.direction.auth.request.log.in" />
                  </Button>
                )}
              </Form.Item>
              <Button onClick={onRequestNewPassword} block className="gx-w-100" type="secondary">
                <IntlMessages id="work.direction.auth.request.password.resend" />
              </Button>
              <Button onClick={history.goBack} block className="gx-w-100" type="link">
                <IntlMessages id="work.direction.auth.request.password.another.email" />
              </Button>
            </div>
          </Card>
        </Form>
      </BoxContainer>
    </BoxContainer>
  );
};
